import { handleActions } from 'redux-actions';
import { normalize, schema } from 'normalizr';
import types from './types';

// TODO: MOVE
const messageSchema = new schema.Entity('messages');
const messageListSchema = new schema.Array(messageSchema);

const initialState = {
  sortedChannelIds: [],
};

const addMessage = (state, action) => {
  const { channel, message, user: { avatar, avatar_url, first_name, last_name } } = action.payload;
  const normalizedData = normalize([{ ...message, avatar, avatar_url, first_name, last_name }], messageListSchema);
  const isChatInRedux = state[channel.id] !== undefined;
  const hasChatMessages = isChatInRedux && state[channel.id].messages;
  const newState = isChatInRedux ? {
    ...state,
    [channel.id]: { ...state[channel.id],
      messages: hasChatMessages ? { ...state[channel.id].messages,
        result: [...state[channel.id].messages.result, ...normalizedData.result],
        entities: { ...state[channel.id].messages.entities, ...normalizedData.entities.messages },
      } : undefined,
      last_message_at: message.created_at },
  } : state;
  return newState;
};

const addMessages = (state, action) => {
  const { id, data, page, direction, hasMoreDown, leftToLoadDown, searchLoad, hasMoreAbove, loadedMsgCount } = action.payload;
  // next/down messages - 1
  // prev/above messages - 0
  const normalizedData = normalize(data, messageListSchema);
  const newResult = direction ?
    [...normalizedData.result, ...state[id].messages.result] :
    [...state[id].messages.result, ...normalizedData.result];
  const newEntities = direction ?
    { ...normalizedData.entities.messages, ...state[id].messages.entities } :
    { ...state[id].messages.entities, ...normalizedData.entities.messages };
  const newPages = state[id].messages.loadedPages ? [...state[id].messages.loadedPages, page] : [page];
  return {
    ...state,
    [id]: { ...state[id],
      messages: {
        ...state[id].messages,
        hasMoreAbove,
        hasMoreDown,
        searchLoad,
        leftToLoadDown,
        loadedMsgCount,
        loadedPages: newPages,
        result: newResult,
        entities: newEntities,
      } },
  };
};

const addChat = (state, action) => {
  const { id, data, count, page, hasMoreDown, hasMoreAbove, downMsgCount, searchLoad, leftToLoadDown, loadedMsgCount } = action.payload;
  const normalizedData = normalize(data, messageListSchema);
  return {
    ...state,
    [id]: { ...state[id],
      id,
      messages: {
        count,
        //hasMore,
        hasMoreDown,
        hasMoreAbove,
        downMsgCount,
        searchLoad,
        leftToLoadDown,
        loadedMsgCount,
        loadedPages: [page],
        result: normalizedData.result,
        entities: normalizedData.entities.messages,
      },
    },
  };
};

const removeMessage = (state, action) => {
  const { channel_id, id } = action.payload;
  const result = state[channel_id].messages.result
    .filter(item => item !== id);
  const entities = Object.keys(state[channel_id].messages.entities).reduce((object, key) => {
    if (parseInt(key, 10) !== parseInt(id, 10)) {
      object[key] = state[channel_id].messages.entities[key];
    }
    return object;
  }, {});
  return {
    ...state,
    [channel_id]: { ...state[channel_id],
      messages: {
        ...state[channel_id].messages,
        result,
        entities,
      },
    },
  };
};

const editMessage = (state, action) => {
  const { id, channel_id, content, files } = action.payload;
  const editedMessages = {
    ...state[channel_id].messages.entities,
    [id]: { ...state[channel_id].messages.entities[id], content, files },
  };
  return {
    ...state,
    [channel_id]: { ...state[channel_id],
      messages: {
        ...state[channel_id].messages,
        entities: editedMessages,
      } },
  };
};

const changeActiveChat = (state, action) => {
  const { id } = action.payload;
  return {
    ...state,
    activeChat: parseInt(id, 10),
  };
};

const setNewMessage = (state, action) => {
  const { id } = action.payload;
  return {
    ...state,
    newMessageIn: parseInt(id, 10),
  };
};

const clearNewMessage = state => ({
  ...state,
  newMessageIn: undefined,
});


const clearMessenger = state => ({ ...state,
  activeChat: undefined,
  newMessageIn: undefined });

const changeChatAttr = (state, action) => {
  const { attributes, channel_id } = action.payload;
  return { ...state,
    [channel_id]: { ...state[channel_id],
      ...attributes,
    },
  };
};

const setChannelsSorted = (state, action) => {
  const { channelIds, direction } = action.payload;
  //end - 1, start - 0
  const sortedChannelIds = state.sortedChannelIds.filter(ch => !channelIds.includes(ch));
  if (direction) {
    sortedChannelIds.push(...channelIds);
  } else {
    sortedChannelIds.unshift(...channelIds);
  }
  return {
    ...state,
    sortedChannelIds,
  };
};

const changeUserOnlineStatus = (state, action) => {
  const { user_id, is_online } = action.payload;
  const data = Object.assign({}, state);

  if (data.sortedChannelIds.length) {
    for (let i = 0; i < data.sortedChannelIds.length; i += 1) {
      const channel = data[data.sortedChannelIds[i]];
      if (channel && (channel.companion === user_id)) {
        channel.is_online = is_online;
      }
    }
  }

  return data;
};

const clearChat = (state, action) => {
  const { channel_id } = action.payload;
  return {
    ...state,
    [channel_id]: {
      ...state[channel_id],
      messages: undefined,
    },
  };
};


const reducer = handleActions(
  {
    [types.ADD_MESSAGE]: addMessage,
    [types.ADD_CHAT]: addChat,
    [types.EDIT_MESSAGE]: editMessage,
    [types.REMOVE_MESSAGE]: removeMessage,
    [types.ADD_MESSAGES]: addMessages,
    [types.CHANGE_ACTIVE_CHAT]: changeActiveChat,
    [types.SET_NEW_MESSAGE]: setNewMessage,
    [types.CLEAR_NEW_MESSAGE]: clearNewMessage,
    [types.CLEAR_MESSENGER]: clearMessenger,
    [types.CLEAR_CHAT]: clearChat,
    [types.CHANGE_CHAT_ATTR]: changeChatAttr,
    [types.SET_CHANNELS_SORTED]: setChannelsSorted,
    [types.CHANGE_USER_ONLINE_STATUS]: changeUserOnlineStatus,
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/messages/reducers.js